import { DEFAULT_ATTRIBUTES } from '../constants/meteo.js';
import { isUndefined } from 'lodash';
import { FRI_EDU_DATE_STATUS } from '../constants/enums.js';

export const VALID_PHONE_REGEX =
  /^(?:\+([1-9]\d{0,2})[ ]?)?(?:\d{1,4}[ ]?)?\d{3,4}[ ]?\d{3,4}$/;

export const STRONG_PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;

export const DATETIME_FORMAT_DATETIME = 'D.M.YYYY H:mm';
export const DATETIME_FORMAT_DATE = 'D.M.YYYY';
export const DATETIME_FORMAT_TIME = 'H:mm';

export const DATETIME_FORMAT_DATETIME_DB = 'YYYY-MM-DDTHH:mm';

/**
 * Toto moze byt 1, 0 pripadne null a vrati sa z tohto true false
 * @param value
 * @returns {boolean}
 */
export const getBooleanValue = (value) => {
  return !!value;
};

export const transformToUrl = (text) => {
  text = text.replace(/^\s+|\s+$/g, ''); // trim
  text = text.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = 'áäčďžéíľĺňóôŕšťúýžãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;';
  var to = 'aacdzeillnoorstuyzaaaaaeeeeeiiiiooooouuuunc------';
  for (var i = 0, l = from.length; i < l; i++) {
    text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  text = text
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return text;
};

export const daysBetween = (firstDate, secondDate) => {
  return Math.round(Math.abs(+firstDate - +secondDate) / 8.64e7);
};

export const isSameDate = (firstDate, secondDate) => {
  // It will came as dayjs() object

  return (
    firstDate.year() === secondDate.year() &&
    firstDate.month() === secondDate.month() &&
    firstDate.date() === secondDate.date()
  );
};

export const clearDayFromDate = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

export const formattedFullName = (user) => {
  return `${user?.title_before || ''} ${
    user?.first_name || ''
  } ${user?.last_name || ''}${user?.title_after ? ', ' + user.title_after : ''}`;
};

export const formattedMorphUserName = (user) => {
  if (isUndefined(user) || user === null) {
    return '';
  }
  return user.user_type === 'ExternalUser'
    ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
    : formattedFullName(user);
};

export const makeLecturerableOption = (user) => ({
  value: JSON.stringify({
    id: user.id,
    type: user.user_type,
  }),
  label: formattedMorphUserName(user),
});

export const makeSensorAttributeInitials = (attribute) => ({
  id: attribute.id,
  key: attribute.key,
  label: attribute.label,
  icon: attribute.icon,
  order: attribute.order,
  is_graphable: attribute.is_graphable,
  attribute_unit_id: attribute.meteo_attribute_unit_id, //attribute.attribute_unit.id,
});

export const isAttributeKeyDefault = (attributeKey) =>
  attributeKey === DEFAULT_ATTRIBUTES.BATTERY ||
  attributeKey === DEFAULT_ATTRIBUTES.LINK_QUALITY;

export const getFirstCreatedAtFromSensorAttributes = (sensor_attributes) => {
  for (const attribute of sensor_attributes) {
    const created_at = attribute?.sensor_value?.created_at;

    if (!isUndefined(created_at)) {
      return created_at;
    }
  }
};

export const isUserAndItsMorphIdentical = (user, morph) => {
  if (isUndefined(morph) || isUndefined(user)) {
    return false;
  }

  if (morph.user_type !== user.user_type) {
    return false;
  }

  if (user.user_type === 'Person' || user.user_type === 'ExternalUser') {
    return morph.id === user.id;
  }

  throw new Error('Unhandled user type');
};

export const getFilenameFromPath = (path) =>
  path.substring(path.lastIndexOf('/') + 1);

export const getSearchTypeName = (type) => {
  switch (type) {
    case 'departments':
      return 'Katedra';
    case 'news':
      return 'Aktuality';
    case 'articles':
      return 'Články';
    case 'teachers':
      return 'Učitelia';
    case 'files':
      return 'Súbory';
    default:
      return type;
  }
};

// FRI.edu helpers
export const resolveFriEduDateStatus = (state) => {
  const cfg = Object.values(FRI_EDU_DATE_STATUS).find(
    (v) => v && typeof v === 'object' && 'STATE' in v && v.STATE === state,
  );
  return cfg || { LABEL: state, COLOR: 'blue', STATE: state };
};

export const friEduIsRegistrationClosed = (row) => {
  const resolved = resolveFriEduDateStatus(row?.status);
  return resolved?.STATE === FRI_EDU_DATE_STATUS.REGISTRATION_CLOSED.STATE;
};

export const friEduIsRegistrationOpen = (row) => {
  const resolved = resolveFriEduDateStatus(row?.status);
  return resolved?.STATE === FRI_EDU_DATE_STATUS.REGISTRATION_OPEN.STATE;
};

export const friEduIsDateFullyBooked = (row) => {
  const resolved = resolveFriEduDateStatus(row?.status);
  return resolved?.STATE === FRI_EDU_DATE_STATUS.FULLY_BOOKED.STATE;
};

export const friEduGetEnrollDisabledReason = (row, t) => {
  if (friEduIsDateFullyBooked(row)) return t('Termín je plne obsadený');
  if (friEduIsRegistrationOpen(row)) return null;
  if (friEduIsRegistrationClosed(row))
    return t('Registrácia na tento termín je uzavretá');
  const resolved = resolveFriEduDateStatus(row?.status);
  switch (resolved?.STATE) {
    case FRI_EDU_DATE_STATUS.CANCELLED.STATE:
      return t('Termín je zrušený');
    case FRI_EDU_DATE_STATUS.ONGOING.STATE:
      return t('Termín prebieha');
    case FRI_EDU_DATE_STATUS.COMPLETED.STATE:
      return t('Termín je ukončený');
    case FRI_EDU_DATE_STATUS.WAITING.STATE:
      return t('Registrácia ešte nie je otvorená');
    default:
      return t('Registrácia nie je otvorená');
  }
};

export const friEduGetUserParticipantId = (row) => {
  const list = Array.isArray(row?.edu_participants)
    ? row.edu_participants
    : Array.isArray(row?.eduParticipants)
      ? row.eduParticipants
      : [];
  return list && list.length > 0 ? list[0]?.id : undefined;
};

export const friEduIsUserEnrolled = (row) => {
  if (Array.isArray(row?.edu_participants) && row.edu_participants.length > 0)
    return true;
  return typeof row?.user_participates === 'number' && row.user_participates > 0;

};
